import React, { useState } from 'react';
import { withTranslation, WithTranslation } from 'next-i18next';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@lb-classroom/ui';
import classnames from 'classnames';

interface TutorFilterDurationPickerOwnProps {
  updateChosenDuration?: (duration: string | number) => void;
  chosenDuration?: string | number;
}

type TutorFilterDurationPickerProps = TutorFilterDurationPickerOwnProps &
  WithTranslation;

const TutorFilterDurationPicker = (props: TutorFilterDurationPickerProps) => {
  const [show, setShow] = useState(false);
  const { t, updateChosenDuration, chosenDuration } = props;

  const onChoseDuration = (e: React.MouseEvent, value: number) => {
    e.preventDefault();
    updateChosenDuration(value);
    setShow(false);
  };

  const getDurationSentence = () => {
    switch (chosenDuration) {
      case 1:
        return t('student.tutorList.fiftyMins');
      default:
        return t('student.tutorList.twentyFiveMins');
    }
  };

  const handleOpenChange = (flag: boolean) => {
    setShow(flag);
  };

  const wrapClass = classnames(
    'h-16 w-full flex justify-center items-center hover:bg-light-gray border-r border-light-gray',
    {
      'bg-light-gray': show,
    },
  );

  return (
    <DropdownMenu open={show} onOpenChange={handleOpenChange}>
      <DropdownMenuTrigger asChild>
        <a className="cursor-pointer" onClick={(e) => e.preventDefault()}>
          <div className={wrapClass}>{getDurationSentence()}</div>
        </a>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuItem onClick={(e) => onChoseDuration(e, 0)}>
          {t('student.tutorList.twentyFiveMins')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={(e) => onChoseDuration(e, 1)}>
          {t('student.tutorList.fiftyMins')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default withTranslation('common')(TutorFilterDurationPicker);
